import React, { useCallback, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import QRCode from "qrcode.react";
import moment from "moment/moment";
import html2canvas from "html2canvas";

const GameCardDownload = (props) => {
  const modalContentRef1 = useRef(null);
  const captureImage = useCallback(() => {
    const targetElement = modalContentRef1.current;
    if (modalContentRef1.current) {
      html2canvas(targetElement, { useCORS: true }).then((canvas) => {
        const image = canvas.toDataURL("image/png");

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = image;
        downloadLink.download = `MyClubtap-${props.accountDetails?.username}`;

        // Append the link to the document and trigger a click event
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Remove the link from the document
        document.body.removeChild(downloadLink);
      });
    }
  }, [props.accountDetails?.username]);

  const { loadingStates, handleGameCardModalClose } = props;

  const handleModalEntered = useCallback(() => {
    if (loadingStates["game_card"] === false) {
      captureImage();
      handleGameCardModalClose();
    }
  }, [loadingStates, captureImage, handleGameCardModalClose]);
  return (
    <>
      <>
        <Modal
          show={props.showGameShareModal}
          onHide={() => props.setShowGameShareModal(false)}
          size="lg"
          id="playermoreinfo1"
          onEntered={handleModalEntered}
        >
          <div ref={modalContentRef1}>
            <div className="gamevideo">
              <figure>
                <img src="/images/video-img.jpg" alt="img" />
              </figure>
            </div>
            <figure className="user-profile">
              {props.itemDetail && props.itemDetail?.logo && (
                <img
                  src={`${process.env.REACT_APP_UPLOAD_URL}game_logo/${props.itemDetail?.logo}`}
                  width="70"
                  height="70"
                  alt="img"
                />
              )}
              {!props.itemDetail ||
                (!props.itemDetail?.logo && (
                  <img src="images/brand-logo.png" alt="img" />
                ))}
            </figure>
            <div className="profile-content">
              <h4>{props.itemDetail?.game_name}</h4>
              <div className="admindetail">
                <span>
                  <strong>
                    <i
                      className="far fa-calendar-alt"
                      aria-hidden="true"
                      style={{ color: "#CA1744" }}
                    ></i>
                    Start
                  </strong>

                  {props.itemDetail.start_date && (
                    <>
                      {moment(props.itemDetail.start_date).format(
                        "D MMM, h:mma"
                      )}
                    </>
                  )}
                  {!props.itemDetail.start_date && <>-</>}
                </span>

                <span>
                  <strong>
                    <i
                      className="far fa-calendar-alt"
                      aria-hidden="true"
                      style={{ color: "#CA1744" }}
                    ></i>
                    End
                  </strong>

                  {props.itemDetail.end_date && (
                    <>
                      {moment(props.itemDetail.end_date).format("D MMM, h:mma")}
                    </>
                  )}
                  {!props.itemDetail.end_date && <>-</>}
                </span>

                <span>
                  <strong>
                    <i
                      className="fas fa-circle-notch"
                      aria-hidden="true"
                      style={{ color: "#CA1744" }}
                    ></i>
                    Rounds
                  </strong>

                  {props.itemDetail?.total_rounds}
                </span>
                <span>
                  <strong>
                    <i
                      className="fas fa-magic"
                      aria-hidden="true"
                      style={{ color: "#CA1744" }}
                    ></i>
                    Mode
                  </strong>

                  {props.itemDetail?.team_view == 1
                    ? "Position Free"
                    : "Position Based"}
                </span>

                <span>
                  <strong>
                    <i
                      className="fas fa-wallet"
                      aria-hidden="true"
                      style={{ color: "#CA1744" }}
                    ></i>
                    Salary Cap
                  </strong>
                  ${props.itemDetail?.salary_cap}m
                </span>
                <span>
                  <strong>
                    <i
                      className="fas fa-exchange-alt"
                      aria-hidden="true"
                      style={{ color: "#CA1744" }}
                    ></i>
                    Trades
                  </strong>
                  {props.itemDetail?.trades}
                </span>

                <span>
                  <strong>
                    <i
                      className="far fas fa-users-cog"
                      aria-hidden="true"
                      style={{ color: "#CA1744" }}
                    ></i>
                    Team
                  </strong>
                  {props.itemDetail?.team_size} Players
                </span>
                <span>
                  <strong>
                    <i
                      className="far fas fa-credit-card"
                      aria-hidden="true"
                      style={{ color: "#CA1744" }}
                    ></i>
                    Fee
                  </strong>
                  {props.itemDetail?.collect_game_pass === 0 && "Free"}
                  {props.itemDetail?.collect_game_pass === 1 && (
                    <>${props.itemDetail?.game_pass_fee}</>
                  )}
                  {props.itemDetail?.collect_game_pass === 2 && (
                    <>
                      {props.itemDetail?.entry_price_symbol}
                      {props.itemDetail?.game_pass_fee}
                    </>
                  )}
                </span>
                <span>
                  <strong>
                    <i
                      className="fas fa-shield-alt"
                      aria-hidden="true"
                      style={{ color: "#CA1744" }}
                    ></i>
                    Hub
                  </strong>
                  {props.accountDetails?.club_name}
                </span>
              </div>
              <QRCode
                value={`${process.env.REACT_APP_FRONT_URL}account-hub?account_name=${props.accountDetails?.username}`} // The data or link the QR code will encode
                // size={256} // Size of the QR code
                renderAs="canvas" // Render the QR code as a canvas
                includeMargin={true} // Include margins around the QR code
              />

              <p>
                Invite members to join & play fantasy games on{" "}
                {props.accountDetails?.club_name} Fantasy Hub!
              </p>
            </div>
          </div>
        </Modal>
      </>
    </>
  );
};

export default GameCardDownload;
